import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { IngredientsServices } from '../../ingredients/services';
import { ProvidersServices } from '../services';
import { ProductsServices } from '../../products/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-providers-add-select-elements',
  templateUrl: 'providers-add-select-elements.html',
})
export class ProvidersAddSelectElementsPage {

  element_type: any;
  provider_uid: any;
  provider_name: any;
  provider: any;
  loadingPopup: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public globals: Globals,
    public providersServices: ProvidersServices,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    public translate: TranslateService) {
    this.element_type = this.navParams.get('type');
    this.provider_uid = this.navParams.get('provider_uid');
    this.provider_name = this.navParams.get('provider_name');

    this.getProvider();
  }

  async ionViewWillEnter() {
    if (this.element_type == 'ingredients') {
      this.ingredientsServices.provider_ingredients_array_tmp = [];

      await this.ingredientsServices.firestore.collection('ingredients')
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .where('provider_static', '==', this.provider_name)
        .where('sub_recipe', '==', false)
        .get().then(snapshot => {
          snapshot.forEach(doc => {
            var ingredient = doc.data();
            ingredient.UID = doc.id;

            var _array = Array();
            _array.push(ingredient.UID);
            _array.push(ingredient.name);
            _array.push(ingredient.allergens);
            _array.push(ingredient.providers);
            _array.push(ingredient.price_static || 0);
            this.ingredientsServices.provider_ingredients_array_tmp.push(_array);
          });
        });
      this.ingredientsServices.provider_ingredients_array_tmp = [...this.ingredientsServices.provider_ingredients_array_tmp];
    } else {
      this.productsServices.provider_products_array_tmp = [];

      await this.ingredientsServices.firestore.collection('products')
        .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
        .where('provider_static', '==', this.provider_name)
        .where('sub_recipe', '==', false)
        .get().then(snapshot => {
          snapshot.forEach(doc => {
            var product = doc.data();
            product.UID = doc.id;

            var _array = Array();
            _array.push(product.UID);
            _array.push(this.globals.nameLangSelectProduct(product));
            _array.push(product.allergens);
            _array.push(product.providers);
            _array.push(product.price_static || 0);
            this.productsServices.provider_products_array_tmp.push(_array);
          });
        });
      this.productsServices.provider_products_array_tmp = [...this.productsServices.provider_products_array_tmp];
    }
  }

  async getProvider() {
    this.provider = await this.providersServices.getProvider(this.provider_uid);
  }

  setProviderDefault() {
    this.loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-anadiendo-proveedor')
    });

    if (this.element_type == 'ingredients') {
      if (this.ingredientsServices.provider_ingredients_array_tmp.length > 0) {//minimo 1 elemento
        this.loadingPopup.present();
        this.setIngredientsDefault();
      } else {
        var toastIng = this.toastCtrl.create({
          message: this.translate.instant('instant-selecciona-ingrediente'),
          duration: 3000,
          position: 'bottom'
        });
        toastIng.present();
      }
    } else {
      if (this.productsServices.provider_products_array_tmp.length > 0) {//minimo 1 elemento
        this.loadingPopup.present();
        this.setProductsDefault();
      } else {
        var toastProd = this.toastCtrl.create({
          message: this.translate.instant('instant-selecciona-producto'),
          duration: 3000,
          position: 'bottom'
        });
        toastProd.present();
      }
    }
  }

  setIngredientsDefault() {
    var loop = 0;
    for (let ingredient of this.ingredientsServices.provider_ingredients_array_tmp) {//recorrer ingredientes
      var providers = this.globals.objectToArray(ingredient[3]);//pasar los proveedores de obj a array
      //desmarcar default
      const i = providers.findIndex(provider => provider.default === true);
      var price_static = ingredient[4];
      var pricetotal_static = ingredient[4];
      var tax_static = 0;
      if (i >= 0) {
        providers[i].default = false;
        price_static = providers[i].price_static;
        pricetotal_static = providers[i].pricetotal_static;
        tax_static = providers[i].tax_static;
      }
      //existe proveedor??
      const j = providers.findIndex(provider => provider.uid === this.provider_uid);
      if (j >= 0) { //si (marcar default)
        providers[j].default = true;
      } else {//no (añadir a array y marcar default)
        providers.push({
          uid: this.provider_uid,
          default: true,
          price_static: price_static,
          name_static: this.provider.name,
          pricetotal_static: pricetotal_static,
          tax_static: tax_static,
          updated_at: new Date(),
        });
      }
      //update firebase
      this.ingredientsServices.afs.collection('ingredients').doc(ingredient[0]).update({
        'provider_static': this.provider.name,
        'price_static': price_static,
        'providers': providers,
      }).then(() => {
        loop++;
        if (loop == this.ingredientsServices.provider_ingredients_array_tmp.length) {
          this.cleanAndSetRoot();
        }
      });
    }
  }

  setProductsDefault() {
    var loop = 0;
    for (let product of this.productsServices.provider_products_array_tmp) {//recorrer ingredientes
      var providers = this.globals.objectToArray(product[3]);//pasar los proveedores de obj a array
      //desmarcar default
      const i = providers.findIndex(provider => provider.default === true);
      var price_static = product[4] || 0; // Usar el precio del producto como valor por defecto
      var pricetotal_static = product[4] || 0; // Usar el precio del producto como valor por defecto
      var tax_static = 0; // Valor por defecto para el impuesto
      if (i >= 0) {
        providers[i].default = false;
        price_static = providers[i].price_static;
        pricetotal_static = providers[i].pricetotal_static;
        tax_static = providers[i].tax_static;
      }
      //existe proveedor??
      const j = providers.findIndex(provider => provider.uid === this.provider_uid);
      if (j >= 0) { //si (marcar default)
        providers[j].default = true;
      } else {//no (añadir a array y marcar default)
        providers.push({
          uid: this.provider_uid,
          default: true,
          price_static: price_static,
          name_static: this.provider.name,
          pricetotal_static: pricetotal_static,
          tax_static: tax_static,
          updated_at: new Date(),
        });
      }
      //update firebase
      this.productsServices.afs.collection('products').doc(product[0]).update({
        'provider_static': this.provider.name,
        'price_static': price_static,
        'providers': providers,
      }).then(() => {
        loop++;
        if (loop == this.productsServices.provider_products_array_tmp.length) {
          this.cleanAndSetRoot();
        }
      });
    }
  }

  cleanAndSetRoot() {
    this.ingredientsServices.provider_ingredients_array_tmp = Array();
    this.productsServices.provider_products_array_tmp = Array();
    this.loadingPopup.dismiss();
    this.navCtrl.pop();
  }

  searchIngredientNode(value, type) {
    this.ingredientsServices.searchIngredientNode(value, type);
  }
  searchProductNode(value, type) {
    this.productsServices.searchProductNode(value, type);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/providers/providers-add-select-elements/providers-add-select-elements.ts